export const DIMENSIONS = {
  MODAL_WIDTH: 600,
  MODAL_HEIGHT: 400,
  SIDEBAR_WIDTH: 280,
  HEADER_HEIGHT: 64,
  TOOLTIP_WIDTH: 200,
  TOOLTIP_HEIGHT: 100,
  MAP_MIN_ZOOM: 0.8,
  MAP_MAX_ZOOM: 12,
  MAP_HEIGHT_RATIO: 0.6,
  MAP_ZOOM_SCALE: 1.2,
  MIN_PAGES_FOR_ELLIPSIS: 4,
  MAX_SNACKS_DISPLAYED: 3,
} as const;

export const TIMEOUTS = {
  DEBOUNCE_SEARCH: 300,
  DEBOUNCE_RESIZE: 250,
  API_TIMEOUT: 10000,
  TOAST_DURATION: 5000,
  TOKEN_REFRESH_CHECK: 5000,
  TOKEN_REFRESH_TIMEOUT: 30000,
  LOCK_TIMEOUT: 30000,
  MAX_WAIT_TIME: 60000,
  INTERVAL_CHECK: 1000,
  MAP_DEBOUNCE: 250,
  TIMER_INTERVAL: 1000,
} as const;
